import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('USERS', ['USERNAME_PASSWORD'])
